const validate = values => {
    const errors = {}
    if (!values.firstName) {
      errors.firstName = 'Wymagane'
    }
    if (!values.lastName) {
      errors.lastName = 'Wymagane'
    }
    if (!values.email) {
      errors.email = "Wymagane"
    }
    if(values.email && !values.email.includes("@")) {
        errors.email = "Email musi zawierać znak @";
    }
    if(!values.phone){
        errors.phone="Wymagane"
    }
    if(!values.town){
        errors.town="Wymagane"
    }
    if(!values.subject){
        errors.subject="Wymagane"
    }
    if(!values.availableTime){
        errors.availableTime="Wymagane"
    }
    if(!values.education){
        errors.education="Wymagane"
    }
    if(!values.childEducationExperience){
        errors.childEducationExperience="Wymagane"
    }
    if(!values.examinator){
        errors.examinator="Wymagane"
    }

    if(!values.workingAtSchool){
        errors.workingAtSchool="Wymagane"
    }
    if(values.workingAtSchool && values.workingAtSchool === "tak"){
        if(!values.workingSchool){
            errors.workingSchool="Wymagane"
        }
    }

    if(!values.currentWork){
        errors.currentWork="Wymagane"
    }

    if(!values.specialFeatures){
        errors.specialFeatures="Wymagane"
    }

    if(!values.achievments){
        errors.achievments="Wymagane"
    }

    if(!values.rodo){
        errors.rodo="Wymagane"
    }

    if(!values.file){
        errors.file="Wymagane"
    }

    if(!values.video){
        errors.video="Wymagane"
    }
    return errors
  }
  export default validate